// extracted by mini-css-extract-plugin
export default {"TechnologyTitle":"t_lWY","TechnologyTitle__icon":"pA7Jr"};